module.exports = __webpack_public_path__ + "img/codeigniter-banner.012102f4.webp";